import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { DeliverablesSection } from '../components/sections/DeliverablesSection';
import { BeforeAfterSection } from '../components/sections/BeforeAfterSection';
import { ChallengeSection } from '../components/sections/ChallengeSection';
import { SituationsSection } from '../components/sections/SituationsSection';
import { VolumesSection } from '../components/sections/VolumesSection';
import { BonusesSection } from '../components/sections/BonusesSection';
import { DifferenceSection } from '../components/sections/DifferenceSection';
import { OfferSection } from '../components/sections/OfferSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { AuthorSection } from '../components/sections/AuthorSection';
import { FaqSection } from '../components/sections/FaqSection';
import { FinalCtaSection } from '../components/sections/FinalCtaSection';
import { DisclaimerFooter } from '../components/sections/DisclaimerFooter';
import { FloatingCta } from '../components/FloatingCta';
import { PurchasePopup } from '../components/PurchasePopup';
export function SalesPage() {
  return <div className="w-full overflow-x-hidden bg-navy-900" data-id="element-349" data-mp="2vwna0flalmgu">
      <HeroSection data-id="element-350" data-mp="3tiubvhq7p0pi" />
      <main data-id="element-351" data-mp="3ti2i8cg6dd1v">
        <ProblemSection data-id="element-352" data-mp="3tht1zgkxmk9d" />
        <DeliverablesSection data-id="element-353" data-mp="3ojhsj6yjubro" />
        <BeforeAfterSection data-id="element-354" data-mp="3oj83bllbw8n1" />
        <ChallengeSection data-id="element-355" data-mp="3ok0yrqeu7bpv" />
        <SituationsSection data-id="element-356" data-mp="3ohom9srultk7" />
        <VolumesSection data-id="element-357" data-mp="3jjveivawcrht" />
        <BonusesSection data-id="element-358" data-mp="3jj3jpmp4ixsl" />
        <DifferenceSection data-id="element-359" data-mp="3jilh88bvbnc8" />
        <OfferSection data-id="element-360" data-mp="3fitbe3duzvak" />
        <GuaranteeSection data-id="element-361" data-mp="3fjkz6s17soqa" />
        <TestimonialsSection data-id="element-362" data-mp="3fi9umpzy3cy4" />
        <AuthorSection data-id="element-363" data-mp="3fl5s6d7vrzm1" />
        <FaqSection data-id="element-364" data-mp="285rb6yif5r03" />
        <FinalCtaSection data-id="element-365" data-mp="286at4f82kfe4" />
      </main>
      <DisclaimerFooter data-id="element-366" data-mp="283538xrm99hc" />
      <FloatingCta data-id="element-367" data-mp="243wbfyg4zlof" />
      <PurchasePopup data-id="element-368" data-mp="243ehx9kuzlk7" />
    </div>;
}